import React from 'react';
import { Translate } from 'react-jhipster';
import { useLocation } from 'react-router';
import { Alert } from 'reactstrap';

const PageNotFound = () => {
  const location = useLocation();
  console.log(location.pathname);

  return (
    <div>
      <Alert color="danger">
        <Translate contentKey="error.http.404">The page does not exist.</Translate>
      </Alert>
    </div>
  );
};

export default PageNotFound;
